import React, { useEffect } from 'react';
import {
	CheckCheck,
	LockKeyhole,
	User,
	ArrowLeft,
	FileText,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import cssConfig from '../../../config/cssConfig';

interface RegisterProps {
	componentState: number;
	canGoBack: boolean;
	onBack: () => void;
}

const RegisterHeaderComponent: React.FC<RegisterProps> = ({
	componentState,
	canGoBack,
	onBack,
}) => {
	useEffect(() => {
		cssConfig.setHeaderTranspartent();
		window.scrollTo(0, 0);
	}, [componentState]);

	window!.onscroll = function() {
		cssConfig.handleHeaderState();
	};

	let linkClassName;
	let lastClassName;

	if (componentState <= 3) {
		linkClassName = 'cyber-steps__item';
	} else if (componentState === 4) {
		linkClassName = 'cyber-steps__item active';
	} else {
		linkClassName = 'cyber-steps__item done';
	}

	if (componentState === 8) {
		lastClassName = 'cyber-steps__item done';
	} else if (componentState < 5) {
		lastClassName = 'cyber-steps__item';
	} else {
		lastClassName = 'cyber-steps__item active';
	}

	return (
		<div id="header" className="cyber-header">
			<div className="cyber-container flex">
				<div className="cyber-header__column-left">
					{canGoBack && (
						<Link to="#" onClick={onBack}>
							<ArrowLeft />
						</Link>
					)}
				</div>
				<div className="cyber-header__column-center">
					<div className="cyber-steps">
						<Link
							to="#"
							className={
								componentState <= 2
									? 'cyber-steps__item active'
									: 'cyber-steps__item done'
							}
						>
							<div className="cyber-steps__item-icon">
								<FileText style={{ stroke: 'white' }} />
							</div>
							<span className="cyber-steps__item-label">
								Información personal
							</span>
						</Link>
						<Link to="#" className={linkClassName}>
							<div className="cyber-steps__item-icon">
								<User style={{ stroke: 'white' }} />
							</div>
							<span className="cyber-steps__item-label">
								Comprueba tu identidad
							</span>
						</Link>
						<Link to="#" className={lastClassName}>
							<div className="cyber-steps__item-icon">
								<LockKeyhole
									style={
										componentState == 4
											? { stroke: '#91939d' }
											: { stroke: 'white' }
									}
								/>
							</div>
							<span className="cyber-steps__item-label">
								Autenticación a 2 pasos
							</span>
						</Link>
					</div>
				</div>
				<div className="cyber-header__column-right"></div>
			</div>
		</div>
	);
};

export default RegisterHeaderComponent;
